<template>
  <div class="footer-table">
    <div class="view-page">
      แสดงผล
      <select v-model="pageSize" name="cars" class="page-size" @change="pageSizeHandleBlur(pageSize)">
        <option v-for="(item, index) in totalArr" :key="index" :value="item">{{ item }}</option>
      </select>
      จากทั้งหมด
      {{ total }}
    </div>
    <div class="pageination">
      <button type="button" class="page-link first" :disabled="!(page != 1)" @click="pageinationClick(active - 1)">
        ก่อนหน้า
      </button>
      <button
        v-for="(pageNumber, index) in pages"
        :key="index"
        type="button"
        class="page-link"
        :class="pageNumber == '...' ? 'no-click' : pageNumber == active ? 'active' : ''"
        @click="pageinationClick(pageNumber)"
      >
        {{ pageNumber }}
      </button>
      <button type="button" class="page-link end" :disabled="!(page < lastPage)" @click="pageinationClick(active + 1)">
        ถัดไป
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentPagination',
  props: ['pageination'],
  data() {
    return {
      pages: [],
      totalArr2: [2, 5, 10, 20, 30, 40],
      page: 1,
      total: 1,
      active: 1,
      pageSize: 50,
      pageSizeTotal: 50,
      lastPage: 1,
      totalArr: [],
    }
  },
  watch: {
    'pageination.lastPage'() {
      this.setPages()
    },
    'pageination.page'() {
      this.page = this.pageination.page
      this.setPages()
    },
    'pageination.total'() {
      this.total = this.pageination.total
      this.setPages()
    },
    'pageination.pageSize'() {
      this.setPages()
    },
    'pageination.pageSizeTotal'() {
      this.setPages()
    },
    'pageination.active'() {
      this.setPages()
    },
  },
  mounted() {
    this.setPages()
  },
  methods: {
    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    pageSizeHandleBlur(data) {
      if (data < 1) {
        data = 1
        this.pageSize = 1
      }

      let newData = {
        page: 1,
        pageSize: data,
      }
      this.$emit('changePageination', newData)
    },
    pageinationClick(data) {
      let newData = {
        page: data,
        pageSize: this.pageSize,
      }
      this.$emit('changePageination', newData)
    },
    setPages() {
      this.lastPage = this.pageination.lastPage == 0 ? 1 : this.pageination.lastPage
      this.pageSize = this.pageination.pageSize == 0 || this.pageination.pageSize == '' ? 50 : this.pageination.pageSize
      this.pageSizeTotal =
        this.pageination.pageSizeTotal == 0 || this.pageination.pageSizeTotal == ''
          ? 50
          : this.pageination.pageSizeTotal
      this.active = this.pageination.active == 0 ? 1 : this.pageination.active
      this.page = this.pageination.active == 0 ? 1 : this.pageination.active
      this.total = this.pageination.total

      this.pages = []
      for (let index = this.page; index <= this.lastPage; index++) {
        if (this.lastPage - this.page >= 5) {
          if (index < 3 + this.page) {
            this.pages.push(index)
          } else if (index == 4 + this.page) {
            this.pages.push('...')
          } else if (index == this.lastPage) {
            this.pages.push(index)
          }
        } else {
          if (index == this.lastPage) {
            for (let index2 = this.page - (4 - (this.lastPage - this.page)); index2 <= this.lastPage; index2++) {
              if (index2 > 0) {
                this.pages.push(index2)
              }
            }
          }
        }
      }

      this.totalArr = []
      if (this.total < this.pageSizeTotal) {
        this.totalArr.push(this.pageSizeTotal)
      } else {
        for (let index = 1; index <= this.total; index++) {
          if (index % this.pageSizeTotal == 0) {
            this.totalArr.push(index)
          }
        }
        if (this.total % this.pageSizeTotal != 0) {
          this.totalArr.push(this.totalArr[this.totalArr.length - 1] + this.pageSizeTotal)
        }
      }
    },
  },
}
</script>
<style scoped lang="scss">
.footer-table {
  .no-click {
    pointer-events: none;
  }

  display: flex;
  align-items: center;
  justify-content: space-between;

  .view-page {
    font-size: 16px;
    font-weight: 500;
    color: #3c4858;
    display: flex;
    align-items: center;
    gap: 10px;

    .page-size {
      width: 100px;
      padding: 10px;
      border: solid 1px #c1cfe3;
      border-radius: 5px;
      background-color: #fff;
      font-size: 16px;
      font-weight: 600;
      color: #3c4858;
    }

    .page-size:focus {
      outline: none;
      box-shadow: 0px 0px;
    }
  }

  .pageination {
    display: flex;
    justify-content: flex-end;
    margin-right: 1px;

    .page-link {
      border: solid 1px #c1cfe3;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      padding: 10px 15px;
      color: #15466e;
    }

    .page-link:not(:last-child) {
      border-right: none;
    }

    .first {
      font-weight: 500;
      color: #3c4858;
      border-bottom-left-radius: 5px;
      border-top-left-radius: 5px;
      padding: 10px 15px;
    }

    .end {
      font-weight: 500;
      color: #3c4858;
      border-bottom-right-radius: 5px;
      border-top-right-radius: 5px;
      padding: 10px 15px;
    }

    .first:disabled,
    .end:disabled {
      color: rgba(21, 70, 110, 0.53);
    }

    .active {
      border: solid 1px #15466e;
      background-color: #15466e;
      color: #fff;
      z-index: 1;
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 10px;

    .view-page {
      .page-size {
        padding: 5px 10px;
      }
    }

    .pageination {
      .page-link {
        padding: 5px 10px;
      }

      .first {
        padding: 5px 10px;
      }

      .end {
        padding: 5px 10px;
      }
    }
  }
}
</style>
